export const LINK = 'link';

/** Available toggleable features */
export enum LINK_FEATURES {
    /** Allow converting a link to a link preview */
    linkPreviewConversion = 'link-preview-conversion',
}
